import { Flex, Button, ButtonProps } from '@chakra-ui/react';

export function AddToPortfolioButton(props: ButtonProps) {
    return (
        <Flex width="full" justifyContent="flex-end" mt={2} pt={4}>
            <Button {...props}>Add to Portfolio</Button>
        </Flex>
    );
}
